module.exports = __webpack_public_path__ + "static/media/star-green.dbbff24e.svg";